/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S5_Li2Inputs */

const en_guide_large_json_files_s5_li2 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>CSV</strong>: More compact for tabular data, supported by all spreadsheet tools`)
};

const ko_guide_large_json_files_s5_li2 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>CSV</strong>: 표 형식 데이터에 더 컴팩트, 모든 스프레드시트 도구에서 지원`)
};

const ja_guide_large_json_files_s5_li2 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>CSV</strong>: 表形式データにはよりコンパクト、すべてのスプレッドシートツールでサポート`)
};

/**
* | output |
* | --- |
* | "<strong>CSV</strong>: More compact for tabular data, supported by all spreadsheet tools" |
*
* @param {Guide_Large_Json_Files_S5_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s5_li2 = /** @type {((inputs?: Guide_Large_Json_Files_S5_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S5_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s5_li2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s5_li2(inputs)
	return ja_guide_large_json_files_s5_li2(inputs)
});